module.exports = __webpack_public_path__ + "static/media/help-grey.21605e8a.svg";